import { Dialog } from "@mui/material";
import styles from "./MultiAccountOrderModal.module.css";

function BookOrderDialogShell({
  open,
  onClose,
  paperClassName = "",
  layoutVariant = "holding",
  showTitleBar = true,
  title = "Multi Account Order Entry",
  header,
  children,
  footer,
  orderEntryGrid = false,
  /** When true, backdrop / Escape / close button do not dismiss the dialog */
  closeDisabled = false,
}) {
  const paperClasses = [styles["modal-dialog-paper"], paperClassName].filter(Boolean).join(" ").trim();
  const containerClasses = [
    styles["modal-dialog-container"],
    layoutVariant === "position" ? styles.positionSqModal : "",
    orderEntryGrid ? styles.orderEntryGrid : "",
  ]
    .filter(Boolean)
    .join(" ");

  const handleDialogClose = (event, reason) => {
    if (closeDisabled) return;
    onClose(event, reason);
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      maxWidth="lg"
      fullWidth
      disableEscapeKeyDown={closeDisabled}
      PaperProps={{ className: paperClasses }}
    >
      <div className={containerClasses}>
        {showTitleBar && (
          <div className={styles["modal-title-bar"]}>
            <h2 className={styles["modal-title"]}>{title}</h2>
            <button
              type="button"
              className={styles["modal-close-btn"]}
              onClick={() => handleDialogClose()}
              disabled={closeDisabled}
              aria-label="Close"
            >
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        )}

        {header != null && <div className={styles["modal-header-wrapper"]}>{header}</div>}

        <div className={styles["modal-body-wrapper"]}>{children}</div>

        {footer != null && <div className={styles["modal-footer"]}>{footer}</div>}
      </div>
    </Dialog>
  );
}

export default BookOrderDialogShell;
